###
# Группа модификаторов
###

App.ModifierScheme = DS.Model.extend
  base_price                : DS.attr 'number', defaultValue: 0
  allow_additional_comment  : DS.attr 'boolean', defaultValue: true
  draft_configurable        : DS.belongsTo 'dish', async: true
  modifier_scheme_items     : DS.hasMany 'modifierSchemeItem', async: true
  schemeItemsSortOrder      : ['view_order']
  sortedModifierSchemeItems : Em.computed.sort('modifier_scheme_items', 'schemeItemsSortOrder')

  restaurant_prices         : DS.hasMany 'modifier_scheme_restaurant_price', async: false
  restaurantsSortOrder      : ['restaurant.city','restaurant.name']
  sortedRestaurantPrices    : Em.computed.sort('restaurant_prices', 'restaurantsSortOrder')

  visibleItems: (->
    @get('sortedModifierSchemeItems').filter((el)->
      !(el.get('_destroy'))
    )
  ).property('modifier_scheme_items.[]', 'modifier_scheme_items.@each._destroy')
